import {
	CommunityPostNotificationDataViewModel,
	CommunityPostReactionNotificationDataViewModel
} from "client/Api/Notifications/notifications";
import { CommunityPostDialog } from "client/Features/Hub/Communities/CommunityPostDialog";
import { ReactElement } from "react";

export type CommunityPostActivityInvocationProps = {
	data:
		| CommunityPostNotificationDataViewModel
		| CommunityPostReactionNotificationDataViewModel;
	onDismiss: () => void;
};

export const CommunityPostActivityInvocation = (
	props: CommunityPostActivityInvocationProps
): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		postId
	} = data;

	return (
		<CommunityPostDialog
			id={postId}
			onClose={onDismiss}
		/>
	);
};

CommunityPostActivityInvocation.displayName = "CommunityPostActivityInvocation";